export default function isNot(what) {
    return (item) => {
        return item !== what;
    };
}
